module.exports = __webpack_public_path__ + "static/img/er_code.0a72d05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/er_code.jpg
// module id = py1H
// module chunks = 32